<template>
  <div id="seniorSearchList">
    <ul>
      <li
        v-for="(item, index) in contList"
        :key="index"
        @click="seniorClickfn(item)"
      >
        <div
          class="leftCon"
          :style="{
            width:
              item.img || item.poster || item.displayImageUrl || item.CoverImg
                ? 'calc( 100% - 126px )'
                : '100%',
          }"
        >
          <h3>{{ item.Title ? item.Title : item.title }}</h3>
          <p>{{ item.Summary || item.describes || item.note }}</p>
          <div class="listFooterText">
            <span>
              {{
                item.MagazineName ||
                item.BookName ||
                item.sourceName ||
                item.ColumnName ||
                item.magazineName
              }}
            </span>
            <span> {{ item.Year || item.year }} 年 {{ item.Issue || item.issue }} 期</span>
            <span> {{ item.Columns }} </span>
            <span style="padding: 0 0 0 6px">
              {{ item.Author || item.author_name || item.author }}
            </span>
          </div>
        </div>
        <div
          v-if="item.img || item.poster || item.displayImageUrl || item.CoverImg"
          class="rightCon"
        >
          <div class="imgWarp">
            <img
              :src="item.img || item.poster || item.displayImageUrl || item.CoverImg"
              alt=""
            />
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
import { detail } from '@/api/lyl'
import { isResourceUnavailable, RESOURCE_UNAVAILABLE_TEXT } from '@/utils/resourceStatus'

export default {
  name: "SeniorSearchList",
  props: {
    contList: {
      type: Array,
      default() {
        return [];
      },
    },
    selectIndex: {
      type: Number,
      default() {
        return 0;
      },
    },
    resourceType: {
      type: Number,
      default() {
        return 1;
      },
    },
    dataParams:{
      type: Object,
      default(){
        return {}
      }
    }
  },
  data() {
    return {
      opening: false,
    };
  },
  mounted() {},
  methods: {
    async ensureBookAvailable(item) {
      try {
        await detail({
          service_code: this.$store.state.webInfo.service_code,
          type: '3',
          id: item.BookGuid,
          user_unique_code: this.$store.state.user_unique_code || '',
        })
        return true
      } catch (err) {
        const msg = isResourceUnavailable(err)
          ? RESOURCE_UNAVAILABLE_TEXT
          : ((err && err.message) || '打开失败，请稍后重试')
        this.$message.warning(msg)
        return false
      }
    },
    async seniorClickfn(item) {
      // 按资源类型跳转,不依赖 tab 下标(隐藏部分 tab 后下标会变)
      if (this.resourceType == 1) {
        this.detailDispatcher("magazineArticle", item);
        return
      }
      if (this.resourceType == 2) {
        if (this.opening) {
          return
        }
        this.opening = true
        try {
          const available = await this.ensureBookAvailable(item)
          if (!available) {
            return
          }
          this.detailDispatcher("book", item, "seniorSearchList");
        } finally {
          this.opening = false
        }
        return
      }
      if (this.resourceType == 3) {
        const { href } = this.$router.resolve({
          name: "knowledgeLibArticle",
          params: {
            id: item.unique_code,
            secParentId: item.author_unique_code,
          },
        });
        window.open(href, "_blank");
        return
      }
      if (this.resourceType == 15) {
        let data = JSON.stringify(this.dataParams)
          const { href } = this.$router.resolve({
          name: "articleDetails",
          query: {
            TitleID: item.TitleID,
            dataParams:data
          },
        });
        window.open(href, "_blank");
        return
      }
      if (this.resourceType == 4) {
          this.detailDispatcher("knowledgeBook",item,"seniorSearchList")
      }
    },
  },
};
</script>
<style scoped lang="less">
#seniorSearchList {
  width: 100%;
  ul {
    li {
      display: flex;
      padding: 30px 20px 38px 20px;
      transition: 0.2s;
      align-items: center;
      justify-content: space-between;
      .rightCon {
        width: 96px;
        .imgWarp {
          width: 96px;
          height: 96px;
          border-radius: 6px;
          display: flex;
          align-items: center;
          justify-content: center;
          overflow: hidden;
          img {
            width: 100%;
            height: auto;
          }
        }
      }
      .leftCon {
        h3 {
          // font-weight: 600;
          font-size: 18px;
          font-family: AlibabaPuHuiTiM;
          color: #606266;
          line-height: 24px;
          cursor: pointer;
        }
        p {
          font-weight: 500;
          font-size: 13px;
          font-family: AlibabaPuHuiTiR;
          color: #909399;
          line-height: 24px;
          cursor: pointer;
          padding: 20px 0;
        }
        .listFooterText {
          font-size: 12px;
          font-weight: 500;
          font-size: 13px;
          font-family: AlibabaPuHuiTiM;
          color: #909399;
          line-height: 20px;
        }
      }
    }
    li:hover {
      background: rgba(0, 0, 0, 0.05);
    }
  }
}
</style>
